import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="py-24">
      <div className="container-x text-center">
        <div className="kicker mb-2">404</div>
        <h1 className="section-title text-3xl md:text-4xl">Page not found</h1>
        <div className="divider-gold mx-auto" />
        <p className="text-[var(--melopa-muted)] mb-6">The page you are looking for doesn’t exist.</p>
        <Link to="/" className="btn-primary">Go Home</Link>
      </div>
    </div>
  );
}
